import { useCallback, useEffect, useRef } from "react";

export type KeyHandler = (event: KeyboardEvent) => boolean | void;
type KeyConfig = {
  key: string;
  handler: KeyHandler;
};

export const useKeyPressListener = (
  configs: KeyConfig[],
  target: EventTarget = window,
) => {
  const configsRef = useRef(configs);
  configsRef.current = configs;

  const handleKeyDown = useCallback((event: Event) => {
    const keyboardEvent = event as KeyboardEvent;
    for (const config of configsRef.current) {
      if (keyboardEvent.key === config.key) {
        if (!config.handler) continue;
        const returnValue = config.handler(keyboardEvent);

        if (returnValue === true) {
          keyboardEvent.preventDefault();
          keyboardEvent.stopPropagation();
        }

        break;
      }
    }
  }, []);

  useEffect(() => {
    target.addEventListener("keydown", handleKeyDown);
    return () => {
      target.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown, target]);
};
